import React, { useContext, useEffect, useState, FC } from "react";
import { Modal, Button, Popup, Icon } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import axios, { AxiosResponse } from 'axios';
import { config } from '../../contexts/UrlContext';
import { getRequest, postRequest } from "../../services/axiosService";
import AuthContext from '../../contexts/AuthContext';


interface IProps {
    open: boolean,
    onClose: any
}

enum ISupportType {

    InSupport,
    NearingEndOfSupport,
    OutOfSupport
}

interface IAboutDetails {
    softwareVersion: string,
    databaseID: string,
    workgroupServer: string,
    licenseExpiryDate: string,
    cmVersion: string,
    connectedUser: string,
    licenseTo: string
    userType: string,
    supportType: ISupportType,
}

const updateLink = "https://docs.fybsoftware.com.au/docs/cm2webshare-overview"

const About: FC<IProps> = ({ open, onClose }) => {

    const [licenceDets, setLicenceDets] = useState<IAboutDetails>({} as IAboutDetails);
    const currentYear = new Date().getFullYear();
    const [supportColour, setSupportColour] = useState<string>("black");
    const [supportHover, setSupportHover] = useState<string>("");

    const { auth } = useContext(AuthContext);

    useEffect(() => {
        async function getData() {
            await populateAboutData();
        }
        getData();

    }, []);

    const populateAboutData = async () => {
        try {
            let response = await getRequest(auth, `/ContentManager/GetAboutDetails`)
            if (response) {
                const data: IAboutDetails = response.data;
                setLicenceDets(data);
                getSupportDetails(data.supportType);
            }
        } catch (e) {
            let error: any = e;
            console.log(error.response);
            toast.error(error.response.data);
        }
    }

    const getSupportDetails = (supportType: ISupportType) => {
        switch (supportType) {
            case ISupportType.InSupport:
                setSupportColour("black");
                setSupportHover("This version is currently supported");
                break;
            case ISupportType.NearingEndOfSupport:
                setSupportColour("orange");
                setSupportHover("This version is nearing end of support");
                break;
            case ISupportType.OutOfSupport:
                setSupportColour("red");
                setSupportHover("This version is out of support");
                break;
        }
    }

    return (
        <Modal
            id="aboutModal"
            open={open}
            onClose={onClose} >
            <Modal.Header>Software Details</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <div><h4 style={{ display: 'inline-block' }}>CM2WebShare Version:</h4>
                        <span style={{ marginLeft: '5px' }}>
                            <Popup
                                trigger={
                                    <span style={{ color: supportColour }}>
                                        {licenceDets ? licenceDets.softwareVersion : ""}
                                    </span>
                                }
                                content={supportHover}
                                disabled={licenceDets.supportType === ISupportType.InSupport}
                            />
                            <Popup trigger={<Icon className="home-icon" style={{ marginLeft: 10, cursor: "pointer" }} name="sync" onClick={() => { window.open(updateLink) }} />} content="Check for updates" />
                        </span>
                    </div>
                    <div><h4 style={{ display: 'inline-block' }}>CM Version:</h4><span style={{ marginLeft: '5px' }}>{licenceDets ? licenceDets.cmVersion : ""}</span></div>
                    <div><h4 style={{ display: 'inline-block' }}>Dataset ID:</h4><span style={{ marginLeft: '5px' }}>{licenceDets ? licenceDets.databaseID : ""}</span></div>
                    <div><h4 style={{ display: 'inline-block' }}>Workgroup Server:</h4><span style={{ marginLeft: '5px' }}>{licenceDets ? licenceDets.workgroupServer : ""}</span></div>
                    <div><h4 style={{ display: 'inline-block' }}>License To:</h4><span style={{ marginLeft: '5px' }}>{licenceDets ? licenceDets.licenseTo : ""}</span></div>
                    <div><h4 style={{ display: 'inline-block' }}>License Expiry Date:</h4><span style={{ marginLeft: '5px' }}>{licenceDets ? licenceDets.licenseExpiryDate : ""}</span></div>
                    <div><h4 style={{ display: 'inline-block' }}>Connected User:</h4><span style={{ marginLeft: '5px' }}>{licenceDets ? licenceDets.connectedUser : ""}</span></div>
                    <div><h4 style={{ display: 'inline-block' }}>Connected User Type:</h4><span style={{ marginLeft: '5px' }}>{licenceDets ? licenceDets.userType : ""}</span></div>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Modal.Actions
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <span>&copy; FYB Pty Ltd 2016 - {currentYear}</span>
                    <Button
                        onClick={onClose}
                    >Close</Button>
                </Modal.Actions>
            </Modal.Actions>
        </Modal>
    )
}
export default About;